<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<h1>Acknowledgements</h1>
<p style="text-indent:0em">I would like to thank my courageous son, Josh, for helping me find my faith and inspiring me to write.</p><br/>
<p style="text-indent:0em">Also, thank you Mum for listening, Dad for making me laugh in the tough times, Dan and Ross for protecting me, and Susie and Nicole for the good old days!</p><br/>
<p style="text-indent:0em">Finally, I’d like to thank my husband, Adam, for finding me and making my dreams come true.</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?9be94308